import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {NavLink} from 'react-router-dom';

export const Wrapper = styled.div`
  background-color: ${props => props.extraInfo ? props.theme.header.backgroundColor : 'transparent'};
`;

export const Info = styled.div`
  margin-top: ${props => props.theme.margin};
  line-height: ${props => props.theme.header.lineHeight};
`;

export const LogoLink = styled.a`
  line-height: 0;
`;

export const Logo = styled.img`
  margin: ${props => props.isAddOnSite ? props.theme.margin: 0};
  max-width: ${props => props.theme.header.logo.maxWidth};
  max-height: ${props => props.theme.header.logo.maxHeight};
  border-radius: ${props => props.theme.header.logo.radius};
  ${media.medium`
    margin-left: ${props => props.theme.margin};
    max-width: 60%;
  `};
  ${media.small`
    max-width: 50%;
  `};
`;

export const LogoText = styled.h1`
  text-align: center;
  margin-left: ${props => props.theme.margin};
  margin-right: ${props => props.theme.margin};
  font-size: ${props => props.theme.header.logo.fontSize};
  ${media.medium`
    font-size: ${props => props.theme.header.logo.tabletFontSize};
  `};
  ${media.small`
    font-size: ${props => props.theme.header.logo.mobileFontSize};
  `};
`;

export const Contact = styled.div`
  position: absolute;
  left: ${props => props.theme.margin};
  padding-right: ${props => props.theme.padding};
  ${media.medium`
    right: 0;
    left: auto;
    text-align: right;
    max-width: 50%;
  `};
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: ${props => props.theme.header.content.wider.margin};
  width: ${props => props.theme.container.wider.width};
  ${media.wide`
    margin: ${props => props.theme.header.content.wide.margin};
    width: ${props => props.theme.container.wide.width};
  `}
  ${media.medium`
    align-items: flex-start;
  `};
  ${media.small`
    margin: ${props => props.theme.header.content.small.margin};
    width: ${props => props.theme.container.phone.width};
  `}
`;

export const LocateUs = styled.div`
  color: ${props => props.theme.secondaryColor};
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  &::before {
    font-family: 'icomoon';
    content: '\\f041';
    height: 2.2rem;
    font-size: 2.2rem;
    margin-right: ${props => props.theme.margin};
  }
  a {
    font-size: ${props => props.theme.header.locate.fontSize};
    color: ${props => props.theme.secondaryColor};
    text-decoration: underline;
    &:hover {
      color: ${props => props.theme.header.locate.hoverColor};
    }
  }

  ${media.medium`
    justify-content: flex-end;
  `}
  ${media.small`
    width: 14rem;
    justify-content: flex-end;
  `}
`;

export const CallUs = LocateUs.extend`
  display: none;
  ${media.small`
    display: flex;
    &::before {
      content: '\\f095';
    }
  `};
`;

export const Address = styled.div`
  ${media.small`
    display: none;
  `};
`;

export const Phone = styled.a`
  ${media.small`
    display: none;
  `};
`;

export const HeaderStyled = styled.div`
  width: ${props => props.theme.header.maxWidth};
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  ${media.medium`
    width: 100%;
  `};
`;

export const SpecialHeader = styled.div`
  width: 100%;
  height: 9rem;
  background-color: ${props => props.headerColor};
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  ${media.small`
    position: relative;
  `};
`;

export const NavStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-grow: 1;
  flex-wrap: wrap;
`;

export const LinkStyled = styled(NavLink)`
  font-size: ${props => props.theme.header.fontSize};
  color: ${props => props.theme.primaryColor};
  display: inline-block;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  flex-wrap: wrap;
  ${media.small`
    padding: ${props => props.theme.header.linkPadding.small};
  `};
`;

export const LinkHeaderStyled = LinkStyled.extend`
  padding: ${props => props.theme.header.linkPadding.large};
  ${media.small`
    padding: ${props => props.theme.header.linkPadding.small};
  `};
`;

export const LinkDropdownStyled = LinkStyled.extend`
  padding: 0.5rem 1rem;
  ${media.small`
    padding: ${props => props.theme.header.linkPadding.small};
  `};
`;

export const OfflineMenuLinkStyled = styled.div`
  position: relative;
`;

export const DropdownMenu = styled.ul`
  position: absolute;
  top: 80%;
  right: 1rem;
  z-index: 1000;
  padding: 0.4rem 0;
  margin: 0.2rem 0 0;
  list-style: none;
  background-color: ${props => props.theme.header.backgroundColor};
  border-radius: 0.6rem;
  ${media.small`
    top: 100%;
  `};
`;

export const Arrow = styled.span`
  &::before {
    font-family: 'icomoon';
    font-size: ${props => props.theme.header.fontSize};
    color: #fff;
    margin-left: 0.4rem;
    ${media.small`
      font-size: ${props => props.theme.header.mobileFontSize};
    `};
  }
`;

export const ArrowUp = Arrow.extend`
  &::before {
    content: '\\f077';
  }
`;

export const ArrowDown = Arrow.extend`
  &::before {
    content: '\\f078';
  }
`;



// WEBPACK FOOTER //
// ./containers/Header/Header.style.js